'use client';

import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};

/**
 * ClientGate
 *
 * A wrapper component to ensure your component only renders on the client. It renders `null` on the server, and renders the children passed to it on the client.
 * source: https://tkdodo.eu/blog/avoiding-hydration-mismatches-with-use-sync-external-store?ck_subscriber_id=887771030
 *
 * @example
 * ```jsx
 * function MyComponentWithClientGate(props: MyComponentProps) {
 *  <ClientGate>
 *    <MyComponent {...props} />
 *  </ClientGate>
 * }
 * ```
 */
export function ClientGate({ children }) {
  const isServer = useSyncExternalStore(
    emptySubscribe,
    () => false,
    () => true
  );

  return isServer ? null : children;
}
